import React, {useEffect, useState} from 'react';
import './DesktopMenu.css';
import {useNavigate} from "react-router-dom";
import ChangePassword from "../MenuOptions/ChangePassword/ChangePassword";
import axios from "axios";
import loadingGif from "../../../Pages/ChooseCorts/loading.gif";

const DesktopMenu = () => {

    const navigate = useNavigate();
    const [isChangeModalOpen, setIsChangeModalOpen] = useState(false);
    const [name, setName] = useState('');
    const [auth, setAuth] = useState(null);

    useEffect(() => {
        axios.get(`/api/my_name/`, {headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-CSRFToken': getCookie('csrftoken'),
                'Access-Control-Allow-Headers': 'X-CSRFToken'
            }, withCredentials: true})
            .then(res => {
                setAuth(true);
                setName(res.data.name);
                console.log(res.data.name);
            })
            .catch(e => {
                console.log(e);
                if (e.status === 401) {
                    navigate('/login');
                }
                else {
                    setAuth(false);
                    // setAuth(true); // delete after
                }
            })

    }, [setName, setAuth]);

    // if (auth === null) {
    //     return (<div className={'loading-block-auth'}><img src={loadingGif} alt={'Loading...'}
    //                                                        className={'loading-gif-auth'}/></div>);
    // }
    //
    // if (auth === false) {
    //     return (<div className={'access-error'}>Неполадки с доступом, попробуйте зайти позже.</div>);
    // }

    const openChangeModal = () => {
        setIsChangeModalOpen(true);
    }

    const goToProfile = () => {
        navigate('/profile');
    }

    const goToAccount = () => {
        navigate('/account');
    }

    const goToBoxes = () => {
        navigate('/box_reserve');
    }

    const logout = () => {

        axios.get(`/api/logout/`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                //     'X-CSRFToken': getCookie('csrftoken'),
                    'Access-Control-Allow-Headers': 'X-CSRFToken'
                }, withCredentials: true
            }
        )
            .then(res => {
                navigate('/login');
            })
            .catch(e => {
                console.log(e);
            })

    }

    const deleteAccount = () => {

        if (window.confirm('Удаление аккаунта приведёт к потере всех данных, связанных с аккаунтом, по истечении 10 дней. Удалить?')) {
            axios.get(`/api/del_account/`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*',
                        'Access-Control-Allow-Headers': 'X-CSRFToken'
                    }, withCredentials: true
                }
            )
                .then(res => {
                    if (res.status === 200) {
                        alert('Профиль успешно удалён');
                        navigate('/login', {replace: true});
                    }
                })
                .catch(e => {
                    console.log(e);
                })
        }

    }

    return (
        <div className={'desk-menu-container'}>
            <div className={'d-menu-photo-name'}>
                <div className={'d-menu-user-photo'}></div>
                <p className={'d-menu-user-name'}>{name}</p>
            </div>
            <div className={'d-menu-options'}>
                <p className={'d-menu-option'} onClick={() => goToProfile()}>Мои игры</p>
                {/*<p className={'d-menu-option'}>Дополнительное оборудование</p>*/}
                <p className={'d-menu-option'} onClick={() => goToAccount()}>Профиль</p>
                <p className={'d-menu-option'} onClick={() => goToBoxes()}>Система хранения</p>
                {/*<p className={'d-menu-option'} onClick={() => openChangeModal()}>Сменить пароль</p>*/}
                {/*<p className={'d-menu-option d-delete-acc-button'} onClick={() => deleteAccount()}>Удалить профиль</p>*/}
            </div>
            <div className={'d-menu-logout'}>
                <p className={'d-menu-option'} onClick={() => logout()}>Выйти</p>
            </div>

            <ChangePassword
                isOpen={isChangeModalOpen}
                onRequestClose={setIsChangeModalOpen}
            />
        </div>
    );
};

function getCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

export default DesktopMenu;